import type { PartnerData } from '../types/api';
import type { FormDefaults } from './formDefaults';

export const mapPartnerDataToFormDefaults = (data: PartnerData): FormDefaults => ({
  ...(data.loanAmount !== undefined && { loan_amount: data.loanAmount }),
  ...(data.loanPurpose !== undefined && { loan_purpose: data.loanPurpose }),
  ...(data.employmentStatus !== undefined && { employment_status: data.employmentStatus }),
  ...(data.employmentFrequency !== undefined && { employment_frequency: data.employmentFrequency }),
  ...(data.annualIncome !== undefined && { annual_income: data.annualIncome }),
  ...(data.propertyStatus !== undefined && { property_status: data.propertyStatus }),
  ...(data.educationLevel !== undefined && { education_level: data.educationLevel }),
  ...(data.firstName !== undefined && { first_name: data.firstName }),
  ...(data.lastName !== undefined && { last_name: data.lastName }),
  ...(data.email !== undefined && { email: data.email }),
  ...(data.phone !== undefined && { phone: data.phone }),
  ...(data.dob !== undefined && { birth_date: data.dob })
});
